import { axiosInstance } from "@/axios/interceptors";
import { DiscountSchema } from "@/features/discount_codes/schema";
import { ZodSentryReporter } from "@/lib/zod-sentry-reporter";
import { z } from "zod";

export async function getDiscountCodeByUser(locationId: number) {
	const response = await axiosInstance.get(
		`locations/${locationId}/guests/discount_codes`,
	);
	return ZodSentryReporter.parse(z.array(DiscountSchema), response);
}
